export const purposeIds = {
	personalizedAds: {
		test: '68beef6d4e4f62209466a99e',
		production: '68d264368fd3ef35e352eb41',
	},
	thirdPartyContent: {
		test: '68beef6d4e4f62209466a999',
		production: '68d264368fd3ef35e352eb1a',
	},
	webAnalytics: {
		test: '68bee32eba2da784ee23d3db',
		production: '68d264368fd3ef35e352eb0d',
	},
} as const;
